export default __webpack_public_path__ + "static/media/phonecall.b89dbfde.png";